import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

/**
 * Engine fino: inicia UrlContextService antes do PageView.
 */
export class UrlContextEngine {
  private readonly context: PixelRuntimeContext;

  private started = false;

  constructor(context: PixelRuntimeContext) {
    this.context = context;
  }

  init(): void {
    if (this.started) return;
    this.started = true;

    if (!this.context.config.modules.core.enabled) return;

    const urlContext = this.context.services.urlContext;
    if (!urlContext) return;

    urlContext.init();
    this.context.logger.debug('[Pixel] UrlContext engine initialized');
  }

  destroy(): void {
    if (!this.started) return;
    this.context.services.urlContext?.destroy();
    this.started = false;
  }

  /** Alias de destroy — limpeza completa do engine. */
  dispose(): void {
    this.destroy();
  }
}
